import React from 'react'
import styles from './styles.module.css'
import Button from '@components/Button'
import gql from 'graphql-tag'
import useSessionStorageState from '@hooks/useSessionStorageState'
import {useTranslation} from 'next-i18next'
import {useMutate} from '@packages/apollo-hooks'

const clearTableName = async (websiteId, mutate) => {
  await mutate({
    mutation: gql`
      mutation setUserPreferences($websiteId: ID, $tableName: String) {
        preferences: setUserPreferences(websiteId: $websiteId, tableName: $tableName) {
          _id
          tableName
        }
      }
    `,
    variables: {websiteId, tableName: null}
  })
}

const OptionsTableServe = props => {
  const mutate = useMutate()
  const [onTable] = useSessionStorageState('onTable')
  const {preferences} = props
  const {t} = useTranslation('website', {keyPrefix: 'order.options.optionsTableServe'})

  if (onTable) return null

  return (
    <div className={styles.changeTableContainer}>
      <p>
        Estás en la <b>Mesa {preferences.tableName}</b>
        {preferences.store && preferences.store.name !== '' && (
          <span>
            {' '}
            del <b>Local {preferences.store.name}</b>
          </span>
        )}
      </p>
      <Button onClick={() => clearTableName(preferences.websiteId, mutate)}>
        {t('buttonChangePreferences')}
      </Button>
    </div>
  )
}

export default OptionsTableServe
